module.exports = __webpack_public_path__ + "img/10880_L.fca4fde9.png";